import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=6a0473a0&scoped=true"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=6a0473a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0473a0",
  null
  
)

export default component.exports